/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Acc_Type_TitleInputs */

const en_acc_type_title = /** @type {(inputs: Acc_Type_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account Type`)
};

const es_acc_type_title = /** @type {(inputs: Acc_Type_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de Cuenta`)
};

const fr_acc_type_title = /** @type {(inputs: Acc_Type_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de compte`)
};

const de_acc_type_title = /** @type {(inputs: Acc_Type_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontotyp`)
};

const id_acc_type_title = /** @type {(inputs: Acc_Type_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Akun`)
};

/** @type {(inputs: Acc_Type_TitleInputs) => LocalizedString} */
const ja_acc_type_title = en_acc_type_title;

/** @type {(inputs: Acc_Type_TitleInputs) => LocalizedString} */
const zh_acc_type_title = en_acc_type_title;

/** @type {(inputs: Acc_Type_TitleInputs) => LocalizedString} */
const ar_acc_type_title = en_acc_type_title;

/** @type {(inputs: Acc_Type_TitleInputs) => LocalizedString} */
const it_acc_type_title = en_acc_type_title;

/** @type {(inputs: Acc_Type_TitleInputs) => LocalizedString} */
const ru_acc_type_title = en_acc_type_title;

/** @type {(inputs: Acc_Type_TitleInputs) => LocalizedString} */
const pt_acc_type_title = en_acc_type_title;

/** @type {(inputs: Acc_Type_TitleInputs) => LocalizedString} */
const ko_acc_type_title = en_acc_type_title;

/**
* | output |
* | --- |
* | "Account Type" |
*
* @param {Acc_Type_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const acc_type_title = /** @type {((inputs?: Acc_Type_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Acc_Type_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_acc_type_title(inputs)
	if (locale === "es") return es_acc_type_title(inputs)
	if (locale === "fr") return fr_acc_type_title(inputs)
	if (locale === "de") return de_acc_type_title(inputs)
	if (locale === "ja") return ja_acc_type_title(inputs)
	if (locale === "zh") return zh_acc_type_title(inputs)
	if (locale === "ar") return ar_acc_type_title(inputs)
	if (locale === "id") return id_acc_type_title(inputs)
	if (locale === "it") return it_acc_type_title(inputs)
	if (locale === "ru") return ru_acc_type_title(inputs)
	if (locale === "pt") return pt_acc_type_title(inputs)
	return ko_acc_type_title(inputs)
});